<template>
  <div class="three-row-layout-cla">
    <div class="down-part-cla">
      <div class="search-part-cla">
        <slot name="search"></slot>
      </div>
      <div class="table-part-cla">
        <slot name="table"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'zkThreeRow',
  data () {
    return {}
  },
  methods: {},
  mounted () { }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
@content-height: calc(100vh - @headHeight - @breadcrumbHeight -24px);
.three-row-layout-cla {
  min-height: @content-height;

  .down-part-cla {
    position: relative;
    margin-top: 12px;
    border-radius: 2px;
    margin-bottom: 24px;

    .search-part-cla {
      display: flex;
      align-items: center;
      position: relative;
      min-height: 40px;
      line-height: 40px;
      background: #fff;
      border-radius: 2px;
      padding: 10px;
      /deep/ .el-form {
        display: flex;
        align-items: center;
      }
      /deep/ .el-form-item {
        margin-bottom: 0;
        line-height: 30px;
      }
    }
    .table-part-cla {
      position: relative;
      margin-top: 15px;
      min-height: calc(100vh - @headHeight - @breadcrumbHeight -140px);
      background: #fff;
      border-radius: 2px;
      padding: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/threeRow.vue